export default "__VITE_ASSET__50a72b22__"